module.exports = __webpack_public_path__ + "static/media/thoughtcast-logo.9dcd5b15.svg";